import { render, staticRenderFns } from "./MetaItem.vue?vue&type=template&id=2250dc1c"
import script from "./MetaItem.vue?vue&type=script&lang=js"
export * from "./MetaItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports